var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"program-soc-form"},[(_vm.ready)?_c('ValidationObserver',{ref:"firstForm",scopedSlots:_vm._u([{key:"default",fn:function({ handleSubmit }){return [_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},[(_vm.ready)?_c('v-row',{staticClass:"px-5 py-5"},[_c('v-col',{attrs:{"md":"12"}},[_c('div',[_c('v-row',[_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Nama Petani',
                  validation: ['required'],
                  type: 'text',
                  setter: 'name',
                }},model:{value:(_vm.formData.name),callback:function ($$v) {_vm.$set(_vm.formData, "name", $$v)},expression:"formData.name"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Berminat?',
                  validation: ['required'],
                  type: 'select-radio',
                  setter: 'status_program',
                  option: {
                    list_pointer: {
                      label: 'label',
                      code: 'code',
                      display: ['label'],
                    },
                    default_options: [
                      {
                        label: 'Ya',
                        code: 'Ya',
                      },
                      {
                        label: 'Tidak',
                        code: 'Tidak',
                      },
                      {
                        label: 'Ragu - Ragu',
                        code: 'Ragu - Ragu',
                      },
                    ],
                  },
                }},model:{value:(_vm.formData.status_program),callback:function ($$v) {_vm.$set(_vm.formData, "status_program", $$v)},expression:"formData.status_program"}})],1),(_vm.formData.status_program == 'Ya')?_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Status Pengisi Data',
                  validation: ['required'],
                  type: 'select-radio',
                  setter: 'status_program',
                  option: {
                    list_pointer: {
                      label: 'label',
                      code: 'code',
                      display: ['label'],
                    },
                    default_options: [
                      {
                        label: 'Pemilik Lahan',
                        code: 1,
                      },
                      {
                        label: 'Pengelola/Penggarap',
                        code: 2,
                      },
                      {
                        label: 'Lainnya',
                        code: 3,
                      },
                    ],
                  },
                }},model:{value:(_vm.formData.entry_data_status),callback:function ($$v) {_vm.$set(_vm.formData, "entry_data_status", $$v)},expression:"formData.entry_data_status"}})],1):_vm._e(),(_vm.formData.status_program == 'Ya')?_c('v-col',{attrs:{"lg":"6"}},[(_vm.formData.entry_data_status == 3)?_c('geko-input',{attrs:{"item":{
                  label: 'Keterangan Status pengisi data lain',
                  validation: ['required'],
                  type: 'text',
                  setter: 'text',
                }},model:{value:(_vm.formData.enty_data_status_others),callback:function ($$v) {_vm.$set(_vm.formData, "enty_data_status_others", $$v)},expression:"formData.enty_data_status_others"}}):_vm._e()],1):_vm._e(),(_vm.formData.status_program == 'Ya')?_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Pernah Ada Kegiatan Organisasi Di Area Setempat?',
                  validation: ['required'],
                  type: 'select-radio',
                  option: {
                    list_pointer: {
                      label: 'label',
                      code: 'code',
                      display: ['label'],
                    },
                    default_options: [
                      {
                        label: 'Ya, Pernah',
                        code: 1,
                      },
                      {
                        label: 'Tidak Pernah',
                        code: 0,
                      },
                    ],
                  }
                }},model:{value:(_vm.formData.is_program),callback:function ($$v) {_vm.$set(_vm.formData, "is_program", $$v)},expression:"formData.is_program"}})],1):_vm._e(),(_vm.formData.status_program == 'Ya')?_c('v-col',{attrs:{"lg":"6"}},[(_vm.formData.is_program)?_c('geko-input',{attrs:{"item":{
                  label: 'Pernah Ikut Program Tahun',
                  validation: ['required'],
                  type: 'select',
                  option: {
                    list_pointer: {
                      label: 'label',
                      code: 'code',
                      display: ['label'],
                    },
                    default_options: _vm.$_config.programYear.options.map(
                      (x) => {
                        return {
                          label: x,
                          code: x,
                        };
                      }
                    ),
                    list_pointer: {
                      label: 'label',
                      code: 'code',
                      display: ['label'],
                    },
                  }
                }},model:{value:(_vm.formData.is_program_year),callback:function ($$v) {_vm.$set(_vm.formData, "is_program_year", $$v)},expression:"formData.is_program_year"}}):_vm._e()],1):_vm._e(),(_vm.formData.status_program == 'Ya')?_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Jumlah lahan yang ingin diikutkan program',
                  type: 'number',
                }},model:{value:(_vm.formData.lahan_for_program),callback:function ($$v) {_vm.$set(_vm.formData, "lahan_for_program", $$v)},expression:"formData.lahan_for_program"}})],1):_vm._e(),(_vm.formData.status_program == 'Ya')?_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Luas dari lahan yang ingin diikutkan program',
                  type: 'number',
                }},model:{value:(_vm.formData.lahan_for_program_luas),callback:function ($$v) {_vm.$set(_vm.formData, "lahan_for_program_luas", $$v)},expression:"formData.lahan_for_program_luas"}})],1):_vm._e(),(_vm.formData.status_program == 'Ya')?_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Pola Tanam Sebelumnya',
                  type: 'select',
                  setter: 'pattern',
                  default_label: _vm.formData.planting_pattern_name || '',
                  option: {
                    default_options: _vm.defaultData.planting_pattern,
                    list_pointer: {
                      label: 'text',
                      code: 'value',
                      display: ['text'],
                    },
                  },
                }},model:{value:(_vm.formData.pattern),callback:function ($$v) {_vm.$set(_vm.formData, "pattern", $$v)},expression:"formData.pattern"}})],1):_vm._e(),(_vm.formData.status_program == 'Ya')?_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Pola Tanam Yang Diminati',
                  validation: ['required'],
                  type: 'select',
                  setter: 'pattern_new',
                  default_label: _vm.formData.planting_pattern_name || '',
                  option: {
                    default_options: [
                      {
                        value: 'Agroforestry',
                        text: 'Agroforestry',
                      },
                      {
                        value: 'Konservasi',
                        text: 'Konservasi',
                      },
                    ],
                    list_pointer: {
                      label: 'text',
                      code: 'value',
                      display: ['text'],
                    },
                  },
                }},model:{value:(_vm.formData.pattern_new),callback:function ($$v) {_vm.$set(_vm.formData, "pattern_new", $$v)},expression:"formData.pattern_new"}})],1):_vm._e(),(['Ya', 'Ragu - Ragu'].includes(_vm.formData.status_program))?_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Materi Pelatihan (max 2)',
                  validation: ['required'],
                  type: 'select',
                  setter: 'training',
                  api: 'GetTrainingMaterials',
                  default_label: _vm.formData.training_materials_material_name,
                  option: {
                    getterKey: 'data.result',
                    multiple: true,
                    list_pointer: {
                      label: 'material_name',
                      code: 'material_no',
                      display: ['material_name'],
                    },
                  },
                }},model:{value:(_vm.formData.training),callback:function ($$v) {_vm.$set(_vm.formData, "training", $$v)},expression:"formData.training"}})],1):_vm._e(),(_vm.formData.status_program == 'Ya')?_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Pohon Yang Diminati (maks 3)',
                  validation: ['required'],
                  type: 'select',
                  setter: 'training',
                  api: 'GetTreesAll',
                  option: {
                    multiple: true,
                    getterKey: 'data.result.data',
                    list_pointer: {
                      label: 'tree_name',
                      code: 'tree_code',
                      display: ['tree_name'],
                    },
                  },
                }},on:{"selected":function($event){return _vm.onSelectTree(_vm.formData.trees)}},model:{value:(_vm.formData.trees),callback:function ($$v) {_vm.$set(_vm.formData, "trees", $$v)},expression:"formData.trees"}})],1):_vm._e(),_c('v-col',{attrs:{"md":"6"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Foto Minat',
                  validation: ['required'],
                  type: 'upload',
                  api: 'sosialisasi_program/upload.php',
                  directory: 'photos',
                  upload_type: 'image/*',
                  setter: 'photo',
                  view_data: 'farmer_photo',
                  option: {
                    label_hint:
                      'Klik gambar untuk memilih berkas yang akan diunggah',
                    max_size: 5,
                    multiple: false,
                  },
                }},model:{value:(_vm.formData.photo),callback:function ($$v) {_vm.$set(_vm.formData, "photo", $$v)},expression:"formData.photo"}})],1),(_vm.formData.status_program == 'Ya')?_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                  validation: ['required'],
                  label: 'Status legalitas lahan yang dimiliki',
                  type: 'select-radio',
                  option: {
                    default_options:
                      _vm.defaultData.owned_land_legalization_status,
                    list_pointer: {
                      code: 'code',
                      name: 'name',
                      display: ['name'],
                    },
                  },
                }},model:{value:(_vm.formData.owned_land_legalization_status),callback:function ($$v) {_vm.$set(_vm.formData, "owned_land_legalization_status", $$v)},expression:"formData.owned_land_legalization_status"}})],1):_vm._e()],1)],1)]),_c('v-col',{attrs:{"lg":"12"}},[_c('div',{staticClass:"d-flex flex-row",staticStyle:{"justify-content":"flex-end"}},[_c('v-btn',{attrs:{"variant":_vm.$route.query.view === 'create' ? 'success' : 'warning',"type":"submit","disabled":_vm.loading}},[(_vm.$route.query.view === 'create')?_c('v-icon',[_vm._v("mdi-plus")]):_vm._e(),(_vm.$route.query.view === 'update')?_c('v-icon',[_vm._v("mdi-pencil-minus")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.$route.query.view == "create" ? "Tambah" : "Perbarui")+" Petani")])],1)],1)])],1):_vm._e()],1)]}}],null,false,4123199900)}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }